tmDocumentReady = function () {
    return {
        isPosthogCallingFeatureFlags: false,
        highlightedActivityHtml: null,

        trafficSourceLog: function () { // is_from_g_ttd: advertising consent (Consent banner Flow 6)
            if (typeof tmVisitorStore !== 'undefined' && typeof tmUtils !== 'undefined' && tmUtils.consentAllows('advertising')) {
                let isTtdClickSource = typeof tmUtils !== "undefined" ? tmUtils.getParameterFromUrl('ttd_click_source', window.location.href) : null;
                if (isTtdClickSource !== null) {
                    tmVisitorStore.saveDetail('is_from_g_ttd', 'yes');
                }
            }
        },

        /* Saved again on every page view: Safari keeps a cookie set by script for 7 days at most, so the once-only write
           gave a returning Safari visitor a new id, and lost their wishlists, a week after the first visit. Now the 7 days
           run from the last visit (a longer absence still loses it; only a cookie the server sets would keep it) */
        setupVisitorId: function () {
            if (typeof tmVisitorStore !== 'undefined') {
                let identifier = tmVisitorStore.getDetail('identifier');
                if (!identifier) {
                    try {
                        identifier = crypto.randomUUID();
                    } catch (e) {
                        return; /* no crypto.randomUUID: no visitor id, and the rest of document-ready still runs */
                    }
                }
                tmVisitorStore.saveDetails('', '', '', identifier);
            }
        },

        setInternalUser: function () {
            try {
                let isInternalUser = typeof tmUtils !== "undefined" ? tmUtils.getParameterFromUrl('set-internal-user', window.location.href) : null;
                if (isInternalUser !== null) {
                    tmVisitorStore.setAsInternalUser();
                }
            } catch (e) {}
        },
        setInternalUserForPostHog: function () {
            try {
                if (tmVisitorStore.isInternalUser()) {
                    window.posthog.register({
                        'is_tester': true,
                    });
                }
            } catch (e) {}
        },
        saveTagsToCookie: function () {
            if (typeof tmBlogRequestJsVars !== 'undefined') {
                if (tmBlogRequestJsVars.hasOwnProperty('tm_current_product_id')) {
                    tmVisitorStore.addTag('p-' + tmBlogRequestJsVars.tm_current_product_id)
                }
            }
        },
        loadPosthogFeatureFlags: function () {
            /*if (tmDocumentReady.isPosthogCallingFeatureFlags) {
                return;
            }
            if (window.posthog && typeof window.posthog.onFeatureFlags === 'function') {
                if (typeof posthog.getFeatureFlag('xxx') === 'undefined' /!* use any one active flag here. So we do not double load *!/) {
                    tmDocumentReady.isPosthogCallingFeatureFlags = true;
                    posthog.reloadFeatureFlags()
                }
                else {
                    jQuery(document).trigger('postHogFeatureFlagsLoaded'); /!* needed as subsequent request will already have the flags data  *!/
                }
            }*/
        },
       /* applyGtranslateLanguage: function () {
            try {
                let languageCodeFromGetParam = tmUtils.getParameterFromUrl('language', window.location.href);
                if (languageCodeFromGetParam !== null) {
                    doGTranslate('en|' + languageCodeFromGetParam);
                }
            } catch (e) {}
        },*/
        setupForCurrency: function () {
            try {
                let currencyCodeFromGetParam = tmUtils.getParameterFromUrl('currency', window.location.href); // todo: remove later
                if (currencyCodeFromGetParam === null) {
                    currencyCodeFromGetParam = tmUtils.getParameterFromUrl('q_currency', window.location.href);
                }
                if (tmCurrency.getTmCurrencyByCode(currencyCodeFromGetParam) !== null) {
                    tmCurrency.changeCurrency(currencyCodeFromGetParam);
                }
                else {
                    let fallbackCurrency = tmBlogRequestJsVars.hasOwnProperty('tm_current_product_currency') ? tmBlogRequestJsVars.tm_current_product_currency : 'USD';
                    tmCurrency.changeCurrency(tmVisitorStore.getCurrency(fallbackCurrency));
                }
            } catch (e) {}
        },

        /*runObservers: function () {
            try {
                let observer = new MutationObserver((mutationsList, observer) => {
                    observer.disconnect(); // temporarily stop observing, so it does not loop.
                    tmCurrency.currencyUpdateEls();
                    observer.observe(document, {attributes: false, childList: true, characterData: false, subtree: true});
                });
                observer.observe(document, {attributes: false, childList: true, characterData: false, subtree: true});
            } catch (e) {}
        }*/

        listenForPosthogToInit: function () {
            let posthogInitCounter = 1;
            try {
                (function waitForPosthog() {
                    if (window.posthog) {
                        tmDocumentReady.setInternalUserForPostHog();
                        if (window.posthog && typeof window.posthog.onFeatureFlags === 'function') {
                            window.posthog.onFeatureFlags(function (flags) {
                                tmDocumentReady.isPosthogCallingFeatureFlags = false;
                                jQuery(document).trigger('postHogFeatureFlagsLoaded');
                            });
                        }
                        jQuery(document).trigger('postHogInitDone');
                    }
                    else {
                        posthogInitCounter ++;
                        if (posthogInitCounter <= 50) {
                            setTimeout(waitForPosthog, 100);
                        }
                    }
                })();
            } catch (e) {}
        },

        helpCenterAccessed: function () {
            $(document).on("click", ".help-center-link, .pre-chat-help-link button", function(e){
                tmUtils.posthogCapture('help_accessed');
            });
        },

        // a [data-dropdown-toggle] button shows and hides the components/dropdown-menu bubble beside it (the booking
        // view's "Call local contact" number, Peter 2026-10-06); a click anywhere else closes every open one
        dropdownToggle: function () {
            $(document).on("click", "[data-dropdown-toggle]", function(e){
                e.preventDefault();
                e.stopPropagation();
                var $menu = $(this).closest(".c-dropdown-menu-wrapper").find(".c-dropdown-menu").first();
                $("[data-dropdown-toggle]").not(this).attr("aria-expanded", "false").closest(".c-dropdown-menu-wrapper").find(".c-dropdown-menu").addClass("c-hidden");
                $menu.toggleClass("c-hidden");
                $(this).attr("aria-expanded", $menu.hasClass("c-hidden") ? "false" : "true");
            });
            $(document).on("click", function(e){
                if ( $(e.target).closest(".c-dropdown-menu-wrapper").length ) return;
                $("[data-dropdown-toggle]").attr("aria-expanded", "false").closest(".c-dropdown-menu-wrapper").find(".c-dropdown-menu").addClass("c-hidden");
            });
            // a row of the bubble (the booking view's ⋯ menu: a link, or a popup opener) closes it — not the call bubble's
            // number, which stays to be read or copied; Esc closes it too, back on its button
            $(document).on("click", ".c-dropdown-menu a:not([href^='tel:'])", function(){
                var $toggle = $(this).closest(".c-dropdown-menu-wrapper").find("[data-dropdown-toggle]").first();
                if ( !$toggle.length ) return;
                $toggle.attr("aria-expanded", "false").closest(".c-dropdown-menu-wrapper").find(".c-dropdown-menu").addClass("c-hidden");
            });
            $(document).on("keydown", function(e){
                if ( e.key !== "Escape" ) return;
                var $open = $("[data-dropdown-toggle][aria-expanded='true']");
                if ( !$open.length ) return;
                $open.attr("aria-expanded", "false").closest(".c-dropdown-menu-wrapper").find(".c-dropdown-menu").addClass("c-hidden");
                $open.first().trigger("focus");
            });
        },

        pageAnimate: function () {
            try {
                if (window.tmA11yReducedMotion) { // the Accessibility panel's Stop Animations / Seizure Safety (tm-accessibility.js)
                    return;
                }
                let pageAnimationType = tmBlogRequestJsVars.hasOwnProperty('pageAnimation') ? tmBlogRequestJsVars.pageAnimation : '';
                if (typeof tmPageAnimate !== 'undefined') {
                    if (pageAnimationType === 'Fireworks') {
                        tmPageAnimate.fireWorks();
                    }
                    else if (pageAnimationType === 'Snow') {
                        tmPageAnimate.snow();
                    }
                    else if (pageAnimationType === 'School') {
                        tmPageAnimate.school();
                    }
                }

            } catch (e) {}

        },
    }
}(window);

/* Trigger Items on document ready */
(function() {
    jQuery(document).ready(function () {
        tmDocumentReady.setupVisitorId();
        tmDocumentReady.listenForPosthogToInit();
        tmDocumentReady.setInternalUser();
        //tmDocumentReady.applyGtranslateLanguage();
        // what needs cookie consent waits until the choice or the visitor's region is known (tm-consent.js; at once on
        // most page views, up to 1.5 s on a first visit while /cdn-cgi/trace answers)
        let whenConsentKnown = (window.TmConsent && typeof window.TmConsent.ready === 'function') ? window.TmConsent.ready : function (callback) { callback(); };
        whenConsentKnown(function () {
            tmDocumentReady.trafficSourceLog();
            tmDocumentReady.saveTagsToCookie();
            tmVisitorStore.setAttributionCookies();
            tmVisitorStore.setNavigationCookies();
        });
        tmDocumentReady.setupForCurrency();
        //tmDocumentReady.runObservers();
        tmDocumentReady.helpCenterAccessed();
        tmDocumentReady.dropdownToggle();
        tmDocumentReady.pageAnimate();
    });

    jQuery(document).on('postHogLoadFeatureFlags', function() {
        tmDocumentReady.loadPosthogFeatureFlags();
    });

    jQuery(document).on('postHogInitDone', function() {
        /*try {
            posthog.reloadFeatureFlags()
        } catch (e) {}*/
        /*if (typeof tmBlogRequestJsVars === 'undefined') {
            return;
        }
        if (!tmBlogRequestJsVars.tm_is_automated_site) {
            jQuery(document).trigger('postHogLoadFeatureFlags');
        }*/
    });

})();

